<app-icon-button
  icon="incorrect_white"
  border="circle"
  type="primary-dark"
  (clicked)="onClose()"
  class="close-button"
/>
<mat-dialog-content>
  <div class="checkout-container">
    <div class="main">
      <div class="steps">
        @if (data.error || courseAlreadyPurchased()) {
          <div class="info-container">
            @if (data.error) {
              <p class="title">{{ sportysCourseName() }} course is available for purchase on our website.</p>
              <a
                class="description link"
                [href]="data.courseWebPurchaseUrl"
                target="_blank"
              >
                Please continue the checkout process here
              </a>
            } @else if (courseAlreadyPurchased()) {
              <p class="title">You already own {{ sportysCourseName() }}.</p>
              <app-button label="Launch Course" (clicked)="handleDialogClose()" />
            }
          </div>
        } @else {
          <app-stepper [steps]="steps()" (stepClicked)="onStepClicked($event)" />

          <!--
            Have to use this weird approach for the switch statement because angular doesn't
          support multiplae cases (ex: @case(2 || 3) is not working as expected). Instead, we
          can switch on 'true' and have regular conditional statements as cases.
          -->
          @switch (true) {
            @case (activeStepIndex() === 0) {
              @if (!authContextService.isLoggedIn()) {
                @switch (activeForm()) {
                  @case ('sign-in') {
                    <app-sign-in-form
                      [form]="signInForm"
                      [loading]="loading()"
                      [error]="stepOneError()"
                      (signUp)="activateSignUpForm()"
                      (forgotPassword)="activateForgotPasswordForm()"
                      (magicLink)="activateMagicLinkForm()"
                    />
                  }
                  @case ('sign-up') {
                    <app-sign-up-form
                      [form]="signUpForm"
                      [loading]="loading()"
                      [error]="stepOneError()"
                      (signIn)="activateSignInForm()"
                    />
                  }
                  @case ('forgot-password') {
                    <app-forgot-password-form
                      [form]="forgotPasswordForm"
                      [loading]="loading()"
                      [error]="stepOneError()"
                      [showInstructions]="showForgotPasswordInstructions()"
                      (signIn)="activateSignInForm()"
                    />
                  }
                  @case ('magic-link') {
                    <app-magic-link-form
                      [form]="magicLinkForm"
                      [loading]="loading()"
                      [error]="stepOneError()"
                      [showInstructions]="showMagicLinkInstructions()"
                      (signIn)="activateSignInForm()"
                    />
                  }
                }
              } @else {
                <app-contact-info-form [form]="contactInfoForm" [error]="stepOneError()"/>
              }

              <div class="actions">
                @if (!authContextService.isLoggedIn()) {
                  @switch (activeForm()) {
                    @case ('sign-in') {
                      <app-button
                        label="sign in"
                        type="primary-dark"
                        uppercase="true"
                        iconRight="right-arrow-white"
                        letterSpacing="wide"
                        [disabled]="signInForm.invalid || loading()"
                        (clicked)="signIn($event)"
                      />
                    }
                    @case ('sign-up') {
                      <app-button
                        label="sign up"
                        type="primary-dark"
                        uppercase="true"
                        iconRight="right-arrow-white"
                        letterSpacing="wide"
                        [disabled]="signUpForm.invalid || loading()"
                        (clicked)="signUp($event)"
                      />
                    }
                    @case ('forgot-password') {
                      <app-button
                        label="reset"
                        type="primary-dark"
                        uppercase="true"
                        iconRight="right-arrow-white"
                        letterSpacing="wide"
                        [disabled]="forgotPasswordForm.invalid || loading()"
                        (clicked)="resetPassword($event)"
                      />
                    }
                    @case ('magic-link') {
                      <app-button
                        label="sign in with email"
                        type="primary-dark"
                        uppercase="true"
                        iconRight="right-arrow-white"
                        letterSpacing="wide"
                        [disabled]="magicLinkForm.invalid || loading()"
                        (clicked)="signInWithEmail($event)"
                      />
                    }
                  }
                } @else {
                  <app-button
                    label="next"
                    type="primary-dark"
                    uppercase="true"
                    iconRight="right-arrow-white"
                    letterSpacing="wide"
                    [disabled]="contactInfoForm.invalid || loading()"
                    (clicked)="onNextClicked($event)"
                  />
                }
              </div>
            } @case (activeStepIndex() === 1) {
              <app-billing-info-form
                [form]="billingInfoForm"
                [loading]="loading()"
                [error]="stepTwoError()"
                [webPurchaseUrl]="data.courseWebPurchaseUrl"
              />

              <div class="actions space-between">
                <app-button
                  label="previous"
                  uppercase="true"
                  iconLeft="left-arrow-blue"
                  type="secondary"
                  letterSpacing="wide"
                  [disabled]="loading()"
                  (clicked)="onPreviousClicked($event)"
                />
                <app-button
                  label="next"
                  uppercase="true"
                  iconRight="right-arrow-white"
                  type="primary-dark"
                  letterSpacing="wide"
                  [disabled]="billingInfoForm.invalid || loading() || stepTwoError()"
                  (clicked)="onNextClicked($event)"
                />
              </div>
            } @case (activeStepIndex() === 2 || activeStepIndex() === 3) {
              @if (paymentComplete()) {
                <div class="payment-complete">
                  <p class="title">Thank you for ordering {{ sportysCourseName() }}</p>
                  @if (isFircAcr()) {
                    <p class="description">Close this window to refresh the page<br> and upload your CFI documents</p>
                  } @else {
                    <app-button label="Launch Course" (clicked)="handleDialogClose()" />
                  }
                </div>
              } @else {
                @if (activeStepIndex() === 3) {
                  <div class="form">
                    <div class="title">
                      <p>Order Review</p>
                    </div>
                    <div class="horizontal-separator"></div>
                    <div class="order-review">
                      <div>{{ orderReview()?.fullName }}</div>
                      <div>{{ orderReview()?.address }}</div>
                      <div>{{ orderReview()?.cityStateZip }}</div>
                      <div>{{ orderReview()?.phone }}</div>
                    </div>
                  </div>
                }

                <div class="payment-container" [class.loading]="loading()">
                  @if (loading()) {
                    <div class="loading-overlay">
                      <app-loading-spinner/>
                    </div>
                  }
                  <app-braintree-payment
                    #braintreePayment
                    [courseWebAppId]="data.courseId"
                    [cartId]="cartId()"
                    [style.min-height]="activeStepIndex() === 2 ? '210px' : '130px'"
                    (paymentValidityChange)="onPaymentValidityChange($event)"
                    (loadingChange)="onLoadingChange($event)"
                    (paymentComplete)="onPaymentComplete()"
                    (errorCompletingPayment)="onErrorCompletingPayment()"
                  />
                  @if (stepFourError()) {
                    <div class="error-message">
                      {{ stepFourError() }}
                    </div>
                  }
                </div>

                <div class="actions space-between">
                  @if (activeStepIndex() === 2) {
                    <app-button
                      label="previous"
                      uppercase="true"
                      iconLeft="left-arrow-blue"
                      type="secondary"
                      letterSpacing="wide"
                      [disabled]="loading()"
                      (clicked)="onPreviousClicked($event)"
                    />
                    <app-button
                      label="next"
                      uppercase="true"
                      iconRight="right-arrow-white"
                      type="primary-dark"
                      letterSpacing="wide"
                      [disabled]="!paymentValid() || loading() || stepThreeError()"
                      (clicked)="onNextClicked($event)"
                    />
                  } @else if (activeStepIndex() === 3) {
                    <app-button
                      label="previous"
                      uppercase="true"
                      iconLeft="left-arrow-blue"
                      type="secondary"
                      letterSpacing="wide"
                      [disabled]="loading()"
                      (clicked)="onPreviousClicked($event)"
                    />
                    <app-button
                      type="payment"
                      label="complete"
                      uppercase="true"
                      letterSpacing="wide"
                      [disabled]="!paymentValid() || loading() || stepFourError()"
                      (clicked)="completePayment()"
                    />
                  }
                </div>
              }
            }
          }
        }
      </div>
    </div>
    <div class="summary">
      <p class="title">Order summary</p>
      <div class="product">
        <div class="image">
          <img [src]="data.courseShoppingCartImagelUrl || 'assets/images/ye_step1.png'" alt="Product image" />
          <div class="badge">1</div>
        </div>
        <div class="details">
          <div class="name">{{ sportysCourseName() }}</div>
          <div class="price">{{ data.price }}</div>
        </div>
      </div>

      @if (finalPrices().total) {
        <div class="separator"></div>

        <div class="subtotals">
          <div class="total">
            <div>Subtotal</div>
            <div>{{ finalPrices().subTotal | currency }}</div>
          </div>
          <div class="total">
            <div>Tax</div>
            <div>{{ finalPrices().tax | currency }}</div>
          </div>
        </div>

        <div class="separator"></div>

        <div class="total final">
          <div>Total</div>
          <div class="price">{{ finalPrices().total | currency }}</div>
        </div>
      }

      <div class="logo">
        <img src="https://dl.videos.sportys.com/onlinecourse/images/sportys-logo-block-airplane.svg"/>
      </div>
    </div>
  </div>
</mat-dialog-content>
